export const formatTimeToStr = (annualLeave = 0) => {
  const hours = Math.abs(parseInt(annualLeave / 3600)).toString().padStart(2, '0')
  const minutes = Math.abs(parseInt((annualLeave % 3600) / 60)).toString().padStart(2, '0')
  return `${annualLeave < 0 ? '-' : ''}${hours}h${minutes}m`
}